// The token retained for an explicit retry exists only in this page's closure.
// It is never serialized into UI/router state or browser storage.
export function createSessionExit({store,send,changed}){
 let held=null,attempt=0,busy=false;
 const publish=state=>changed(state);
 const run=async()=>{
  if(!held||busy)return;const current=held;
  if(store.version()!==current.version){held=null;publish(null);return;}
  busy=true;const id=++attempt;publish({status:'pending',scope:current.scope});
  try{
   const result=await send(current.token,current.scope);
   if(id!==attempt||store.version()!==current.version){held=null;return;}
   if(result?.ok!==true||result.scope!==current.scope)throw Error('Unconfirmed revocation');
   held=null;publish({status:'confirmed',scope:current.scope});
  }catch(error){
   if(id!==attempt||store.version()!==current.version){held=null;return;}
   if(error?.status===401){held=null;publish({status:'invalid',scope:current.scope});}
   else publish({status:'unconfirmed',scope:current.scope});
  }finally{if(id===attempt)busy=false;}
 };
 return{
  start(scope='current'){
   if(busy)return;
   const token=store.get();store.clear();
   if(!token){held=null;publish({status:'local',scope});return;}
   held={token,scope,version:store.version()};return run();
  },
  retry:run,
  discard(){attempt++;held=null;busy=false;publish(null);}
 };
}
